export const STATUS_COLORS = {
	inprogress: '#FF9800',
	planned:    '#2196F3',
	overdue:    '#BF360C',
	none:       '#546E7A',
};

export const FEATURE_COLORS = {
	'Feature':                    '#2196F3',
	'Optimisation':               '#4CAF50',
	'Parameter Workbook Rollout': '#FF5722',
	'Software Upgrade':           '#9C27B0',
	'Service Protection Period':  '#E91E63',
	'Maintenance':                '#CDDC39',
	'FOA':                        '#FF6F00',
	'Design/Documentation':       '#00BCD4',
};

export const FEATURE_FALLBACK = '#546E7A';